import { api } from '../api'
import { Domain, Organization } from 'models/Organization'
import { ListOrgTagsFilterRequestParams, OrgTag } from 'models/OrganizationTag'
import toAPIv2QueryString from 'utils/functions/toAPIv2QueryString'
import { PlanFeatures } from 'models/PlanFeatures'

const organizationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOrganization: builder.query<Organization, string>({
      query: (organizationId: string) => `/organizations/${organizationId}`,
    }),
    getOrgDomains: builder.query<Domain[], string>({
      query: (organizationId: string) => `/organizations/${organizationId}/domains`,
    }),
    getOrgTags: builder.query<
      { data: OrgTag[] },
      { organizationId: string; params: ListOrgTagsFilterRequestParams }
    >({
      query: ({ organizationId, params }) =>
        `/organizations/${organizationId}/tags?${toAPIv2QueryString(params)}`,
    }),
    getOrgPlanFeatures: builder.query<PlanFeatures, string>({
      query: (organizationId: string) => `/organizations/${organizationId}/plan-features`,
    }),
  }),
})

export const {
  useGetOrganizationQuery,
  useGetOrgDomainsQuery,
  useGetOrgTagsQuery,
  useGetOrgPlanFeaturesQuery,
  endpoints: { getOrganization, getOrgDomains, getOrgTags, getOrgPlanFeatures },
} = organizationApi

export default organizationApi
